<p-dialog header="Перевірка наявності товару" [visible]="display" [modal]="true"
          [style]="{width: '80vw'}" (visibleChange)="onVisibleChange($event)">

  <div class="pf-message pf-message--error" *ngIf="error">{{error}}</div>

  <div class="pf-message pf-message--stale" *ngIf="stale && result">
    Документ змінено після перевірки. Результат застарів і більше не впливає на прапорець документа.
    Збережіть зміни та перевірте знову.
  </div>

  <ng-container *ngIf="result">
    <p class="pf-scope">
      Перевірено збережену версію документа станом на {{result.asOfDate | date:'dd.MM.yyyy'}}.
      Резерви інших документів оцінено на {{result.referenceDate | date:'dd.MM.yyyy'}}
      (дата виконання документа, якщо вона пізніша за сьогодні).
      <span *ngIf="bomScopeNote">{{bomScopeNote}}</span>
      <span *ngIf="result.scope.nestedBomNotExpanded?.length">
        Складові вкладених збірок не розкрито (товарів: {{result.scope.nestedBomNotExpanded.length}}).
      </span>
    </p>

    <p class="pf-clean" *ngIf="!result.findings.length">
      Нестач не виявлено: усі товари документа покриваються вільним залишком.
    </p>

    <div class="pf-finding" *ngFor="let f of result.findings; trackBy: trackFinding"
         [class.pf-finding--stale]="stale">
      <div class="pf-finding-head">
        <p-tag [value]="severityLabel(f.severity)" [severity]="severityTag(f.severity)"></p-tag>
        <strong class="pf-code">{{productLabel(f)}}</strong>
        <span>{{codeText(f.code)}}</span>
      </div>

      <div class="pf-flags" *ngFor="let flag of f.flags">{{flagText(flag)}}</div>

      <div class="pf-bom" *ngIf="bomNeed(f) as need">
        <div>{{need}}</div>
        <ul class="pf-bom-list">
          <li *ngFor="let v of f.bom?.via">{{bomSource(v)}}</li>
        </ul>
      </div>

      <table class="pf-table" *ngIf="f.numbers as n">
        <thead>
          <tr>
            <th *ngFor="let c of columnsOf(n)">{{c.label}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngFor="let c of columnsOf(n)" [class.pf-negative]="cellNegative(c, n)">
              <strong *ngIf="c.strong; else plainNumber">{{cellText(c, n)}}</strong>
              <ng-template #plainNumber>{{cellText(c, n)}}</ng-template>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pf-sub" *ngIf="f.holders.length">
        <div class="pf-sub-title">Хто тримає товар</div>
        <table class="pf-table">
          <thead>
            <tr><th>Документ</th><th>Клієнт</th><th>Утримує</th><th>Стан</th><th>Передано у виробництво</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let h of f.holders">
              <td>
                <p-button *ngIf="holderTarget(h) as t" icon="pi pi-external-link" styleClass="p-button-warning pf-open mr-1" [pTooltip]="openDocumentTooltip"
                          tooltipPosition="top" (onClick)="openDocument(t)"></p-button>
                {{h.docNumber}}
              </td>
              <td>{{h.client}}</td>
              <td>{{h.debts}}</td>
              <td>
                <span *ngIf="h.paid">Оплачено</span>
                <span *ngIf="!h.paid">Резерв до {{h.reservedTill | date:'dd.MM.yyyy'}}</span>
                <span class="pf-lapses" *ngIf="h.lapses"> · спливе до поставки</span>
              </td>
              <td>{{h.manued || 0}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pf-sub" *ngIf="f.orders.length && queueView(f) as q">
        <div class="pf-sub-title">{{q.title}}</div>
        <table class="pf-table" *ngIf="q.hasDates; else queueWithoutDates">
          <thead>
            <tr>
              <th>{{queueColumns.position}}</th><th>{{queueColumns.order}}</th><th>{{queueColumns.placed}}</th>
              <th>{{queueColumns.note}}</th><th>{{queueColumns.open}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of q.rows">
              <td>{{r.position}}</td>
              <td>
                <p-button *ngIf="r.docTarget" icon="pi pi-external-link" styleClass="p-button-warning pf-open mr-1" [pTooltip]="openDocumentTooltip"
                          tooltipPosition="top" (onClick)="openDocument(r.docTarget)"></p-button>
                {{r.docNumber}}
              </td>
              <td>{{r.placed}}</td>
              <td>{{r.note}}</td>
              <td>{{r.open}}</td>
            </tr>
          </tbody>
        </table>
        <ng-template #queueWithoutDates>
          <table class="pf-table">
            <thead>
              <tr><th>{{queueColumns.order}}</th><th>{{queueColumns.open}}</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of q.rows">
                <td>
                  <p-button *ngIf="r.docTarget" icon="pi pi-external-link" styleClass="p-button-warning pf-open mr-1" [pTooltip]="openDocumentTooltip"
                            tooltipPosition="top" (onClick)="openDocument(r.docTarget)"></p-button>
                  {{r.docNumber}}
                </td>
                <td>{{r.open}}</td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>

      <p class="pf-arrival" *ngIf="lastArrivalText(f) as arrival">
        {{arrival}}
        <p-button *ngFor="let l of lastArrivalLinks(f)" icon="pi pi-external-link" styleClass="p-button-warning pf-open ml-1" [label]="l.label"
                  [pTooltip]="openDocumentTooltip" tooltipPosition="top" (onClick)="openDocument(l.target)"></p-button>
      </p>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <p-button label="Перевірити знову" icon="pi pi-refresh" [loading]="loading" [disabled]="!canRecheck || loading"
              (onClick)="onRecheck()"></p-button>
    <p-button label="Закрити" icon="pi pi-times" styleClass="p-button-secondary" (onClick)="onVisibleChange(false)"></p-button>
  </ng-template>
</p-dialog>
